import {
	Grid,
	IconButton,
	InputBase,
	Paper,
	Skeleton,
	styled,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
} from '@mui/material';
import {
	DeleteELIcon,
	EditELIcon,
	LeftArrowIcon,
	SearchIcon,
	ViewELIcon,
} from '../../assets/icons/Icons';
import { dateConverter } from '../../Utils/Helpers';
import { MAIN_THEME_COLOR } from '../../assets/theme/Colors';
import Count from '../../assets/images/Count.gif';
import { ActionButton } from './DataTiles';
import AlertDialog from '../../components/AlertDialog';

function CountTile({ count, name, image }) {
	return (
		<Grid
			item
			xs={12}
			md={3}
			sx={{
				backgroundColor: '#FCFDFF',
				borderRadius: '6px',
				flexDirection: 'row',
				alignItems: 'center',
				display: 'flex',
				paddingX: '24px',
				paddingY: '12px',
				border: '0.6px solid #F1F3FA',
			}}>
			<Grid
				sx={{
					width: '50px',
					height: '50px',
					backgroundColor: '#FFFFFF',
					justifyContent: 'center',
					alignItems: 'center',
					display: 'flex',
					padding: '10px',
					borderRadius: '100px',
				}}>
				<img src={image} width={'40px'} height={'40px'} />
			</Grid>
			<Grid sx={{ flexDirection: 'column', marginLeft: '15px' }}>
				<Typography
					color={'#324054'}
					fontSize={'20px'}
					fontWeight={'600'}>
					{count}
				</Typography>
				<Typography
					color={'#324054'}
					fontSize={'14px'}
					fontWeight={'500'}>
					{name}
				</Typography>
			</Grid>
		</Grid>
	);
}

function ResidentTable({
	data,
	searchedText,
	onSearch,
	page,
	rowsPerPage,
	handleChangePage,
	handleChangeRowsPerPage,
	onClickMore,
	isViewExpanded = false,
	onActionView,
	onActionEdit,
	onActionDelete,
	isLoading,
}) {
	return (
		<Grid
			container
			sx={{
				marginLeft: '30px',
				marginTop: '16px',
				padding: '16px',
				backgroundColor: '#FFFFFF',
			}}>
			<Grid
				container
				sx={{
					flexDirection: 'row',
					justifyContent: 'space-between',
					paddingTop: '16px',
				}}>
				<Grid
					sx={{
						width: '50%',
						flexDirection: 'column',
					}}>
					<Grid
						item
						display={'flex'}
						alignItems={'center'}
						flexDirection={'row'}>
						{isViewExpanded && (
							<IconButton disableRipple onClick={onClickMore}>
								<LeftArrowIcon />
							</IconButton>
						)}
						<Typography
							color={'#191919'}
							fontSize={'18px'}
							marginLeft={isViewExpanded ? '5px' : '0px'}
							fontWeight={'600'}>
							Onboard Resident
						</Typography>
					</Grid>
					<Grid
						width={'50%'}
						justifyContent={'center'}
						alignItems={'center'}
						color={'#777E90'}
						display={'flex'}
						paddingX={'15px'}
						marginTop={'15px'}
						border={'2px #E8E8E8 solid'}
						borderRadius={'8px'}>
						<InputBase
							value={searchedText}
							type={'text'}
							sx={{
								padding: '4px',
								width: '94%',
								color: '#777E90',
							}}
							placeholder={'Search'}
							onChange={e => onSearch(e.target.value)}
						/>
						<SearchIcon />
					</Grid>
				</Grid>
				<CountTile
					count={data.length}
					image={Count}
					name={'Total Onboarded Resident'}
				/>
			</Grid>
			<TableContainer
				component={Paper}
				style={{
					boxShadow: 'none',
					marginTop: '30px',
					border: '1px solid #d4dce4',
				}}>
				<Table
					sx={{
						minWidth: 700,
					}}
					aria-label="customized table">
					<TableHead>
						<TableRow>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Resident ID
								</Typography>
							</StyledTableCell>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Full Name
								</Typography>
							</StyledTableCell>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Onboarded Date
								</Typography>
							</StyledTableCell>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Last Care Note
								</Typography>
							</StyledTableCell>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Last Initial Plan
								</Typography>
							</StyledTableCell>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Last Optimized Plan
								</Typography>
							</StyledTableCell>
							<StyledTableCell align="center">
								<Typography variant="tableHeader">
									Action
								</Typography>
							</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isLoading ? (
							<TableRow>
								{[...Array(7)].map((_, index) => (
									<StyledTableCell key={index} align="center">
										<Skeleton
											animation="wave"
											style={{
												borderRadius: '5px',
												height: 20,
											}}
											variant="rounded"
										/>
									</StyledTableCell>
								))}
							</TableRow>
						) : data && data.length > 0 ? (
							data
								.slice(
									page * rowsPerPage,
									page * rowsPerPage + rowsPerPage,
								)
								.map((item, index) => {
									return (
										<StyledTableRow key={index}>
											<StyledTableCell align="center">
												<Typography variant="tableBody">
													{item.elderId}
												</Typography>
											</StyledTableCell>
											<StyledTableCell align="center">
												<Typography variant="tableBody">
													{item.name}
												</Typography>
											</StyledTableCell>
											<StyledTableCell align="center">
												<Typography variant="tableBody">
													{dateConverter(
														item.onboardDate,
													)}
												</Typography>
											</StyledTableCell>
											<StyledTableCell align="center">
												{dateConverter(
													item.lastCNUpdate,
												)}
											</StyledTableCell>
											<StyledTableCell align="center">
												<Typography variant="tableBody">
													{dateConverter(
														item.lastICPUpdate,
													)}
												</Typography>
											</StyledTableCell>
											<StyledTableCell align="center">
												<Typography variant="tableBody">
													{dateConverter(
														item.lastOCPUpdate,
													)}
												</Typography>
											</StyledTableCell>
											<StyledTableCell align="center">
												<Grid>
													<ActionButton
														BtnIcon={() => (
															<ViewELIcon
																color={
																	'#324054'
																}
															/>
														)}
														onClick={() =>
															onActionView(
																item.id,
																item.isExternalElder,
																item.elderId,
															)
														}
													/>
													<ActionButton
														disabled={
															item.isExternalElder
														}
														BtnIcon={() => (
															<EditELIcon
																color={
																	item.isExternalElder
																		? 'grey'
																		: '#324054'
																}
															/>
														)}
														onClick={() =>
															onActionEdit(
																item.id,
															)
														}
													/>
													<AlertDialog
														id={item.id}
														title={
															'Remove Resident'
														}
														bodyContent={
															'Removing resident will permanently delete all the data of this resident.'
														}
														icon={() => (
															<DeleteELIcon
																color={
																	item.isExternalElder
																		? 'grey'
																		: '#FF4343'
																}
															/>
														)}
														deleteData={
															onActionDelete
														}
														cancelBtnText={
															'Keep the resident'
														}
														deleteBtnText={
															'Remove resident'
														}
														disabled={
															item.isExternalElder
														}
													/>
												</Grid>
											</StyledTableCell>
										</StyledTableRow>
									);
								})
						) : (
							<StyledTableRow>
								<StyledTableCell colSpan={7} align="center">
									<Typography variant="tableBody">
										No data available
									</Typography>
								</StyledTableCell>
							</StyledTableRow>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			{isViewExpanded ? (
				<TablePagination
					rowsPerPageOptions={[]}
					component="div"
					count={data ? data.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			) : (
				<Grid container justifyContent={'flex-end'}>
					<IconButton
						disableFocusRipple
						disableRipple
						onClick={onClickMore}>
						<Typography
							fontSize={'14px'}
							paddingY={'10px'}
							color={MAIN_THEME_COLOR}
							fontWeight={'500'}>{`More >>>`}</Typography>
					</IconButton>
				</Grid>
			)}
		</Grid>
	);
}

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: '#FFFFFF',
		color: 'rgba(0, 0, 0, 0.5)',
		paddingTop: '20px',
		fontSize: 12,
		fontWeight: 600,
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		fontWeight: 400,
		color: '#000000',
		padding: '10px',
	},
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
	'&:nth-of-type(odd)': {
		background:
			'linear-gradient(0deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), #C2C9D1',
	},
	// hide last border
	'&:last-child td, &:last-child th': {
		border: 0,
	},
}));

export default ResidentTable;
